<template>
  <div class="editorCampaign-outdoor">
    <div class="editorCampaign-outdoor__summary-section" v-if="isSummary"  >
      <div class="editorCampaign-outdoor__summary-section__container">  
        <h1 class="subhead title">Campaign Channel Name</h1>
        <div class="editorCampaign-outdoor__summary-section__container__item">
          <adx-input :label="`Campaign Name`" :value.sync="model.name" :inputId="`campaign_name`"
            :error.sync="vuelidateOptions.name.error" :ref="vuelidateOptions.name.ref"/>
        </div>
      </div>
        <div v-if="model.digitalMedia && model.digitalMedia.line_item_list.length > 0" class="editorCampaign-outdoor__summary-section__container">  
          <div class="editorCampaign-outdoor__summary-section__container__title-header">
            <h1 class="subhead title">Campaign Setting</h1>
            <h1 class="mini-font strong color-grey ">DIGITAL</h1>
          </div>
          <div class="editorCampaign-outdoor__summary-section__container__item">
            <div class="periodWrapper">
              <adx-select-dropdown class="periode-dropdown" id="campaign-period" :label="`Media Duration`" 
              :value.sync='model.campaignDuration' :options="durationOptions" :key="durationKey" 
              @selected='updateEndDate($event, model)'/>
            </div>
            <div class="calendarWrapper">
              <div class="editorCampaign-outdoor__summary-section__container__item date">
                <div :class="'calendar'">
                  <v-date-picker
                    v-model="date.digitalStartDate"
                    :popoverVisibility="`focus`"
                    :min-date="minDate(model.digitalMedia)"
                    :theme-styles='themeStyles'
                    :disabled-dates='model.digitalMedia.start'  
                    @input='updateEndDate($event, date.digitalStartDate)'
                    class='date-picker'>
                    <div class="field" slot-scope='{ inputValue, updateValue }'>
                    <div class="start_date">
                      <label class="mini-font calendar-label">Start Date</label>
                      <input
                        class="date-picker-input"
                        type='text'
                        required
                        readonly
                        :value='inputValue? inputValue: `Unset`'
                        @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                        @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'/>
                    </div>
                    </div>
                  </v-date-picker>
                  <div class="arrow">
                    <i class="icon-arrow-forward"></i>
                  </div>
                    <div class="date-picker">
                      <div class="field">
                        <div class="end_date">
                          <label class="mini-font calendar-label">End Date</label>
                          <input
                            class="date-picker-input color-grey"
                            type='text'
                            readonly
                            :value='model.digitalMedia.start? getEndDate(date.digitalStartDate, "digital"): `Unset`'
                            @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                            @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="model.nonDigitalMedia && model.nonDigitalMedia.line_item_list.length > 0" class="editorCampaign-outdoor__summary-section__container">
          <div class="editorCampaign-outdoor__summary-section__container__title-header">
            <h1 class="subhead title">Campaign Setting</h1>
            <h1 class="mini-font strong color-grey ">NON DIGITAL</h1>
          </div>
          <div class="editorCampaign-outdoor__summary-section__container__item">
            <div class="calendarWrapper">
              <div class="editorCampaign-outdoor__summary-section__container__item date">
                <div :class="'calendar'">
                  <v-date-picker
                    v-model='date.nonDigitalStartDate'
                    :popoverVisibility="`focus`"
                    :min-date="minDate(model.nonDigitalMedia)"
                    :theme-styles='themeStyles'
                    :disabled-dates='model.nonDigitalMedia.start'
                     @input='updateEndDate(null, date.nonDigitalStartDate, $event)'
                    class='date-picker'>
                    <div class="field" slot-scope='{ inputValue, updateValue }'>
                    <div class="start_date">
                      <label class="mini-font calendar-label">Start Date</label>
                      <input
                        class="date-picker-input"
                        type='text'
                        required
                        readonly
                        :value='inputValue? inputValue: `Unset`'
                        @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                        @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'/>
                    </div>
                    </div>
                  </v-date-picker>
                  <div class="arrow">
                    <i class="icon-arrow-forward"></i>
                  </div>
                    <div class="date-picker">
                      <div class="field">
                        <div class="end_date">
                          <label class="mini-font calendar-label">End Date</label>
                          <input
                            class="date-picker-input color-grey"
                            type='text'
                            readonly
                            :value='model.nonDigitalMedia.start? getEndDate(date.nonDigitalStartDate, "nonDigital"): `Unset`'
                            @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                            @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <div v-else>
       <div class="editorCampaign-outdoor__summary-section__container">
          <h1 class="subhead title"> Campaign Item(s)</h1>
          <div v-for="(media, ind) in model.campaignMedias" :key="ind+`media_detail`" >
            <div v-for="(item, index) in media.line_item_list" :key="index+`item_detail`">
              <div class="editorCampaign-outdoor__summary-section__container__item">
                <div class="campaign-item">
                  <div class="campaign-item__left">
                    <span class="subhead strong">{{item.line_item.name}}</span>
                    <span class="subhead">{{item.line_item.location_data.name }}</span>
                  </div>
                  <!-- <div class="campaign-item__center periodWrapper" v-if="media.media_type != 'digital'">
                    <adx-select-dropdown class="dropdown" id="campaign-period" :label="`Item / Slot`" :value.sync='item.slot' :options="getUnitItem(item.line_item.quantity)" 
                    @selected="changeItemUnit(ind, index, item)" :key="unitRender"/>
                  </div> -->
                  <div class="campaign-item__right">
                    <div class="campaign-item__right__price">
                      <span class="mini-font color-grey">Price</span>
                      <span class="subhead color-pink strong">{{item.price | formatMoney}}</span>
                    </div>
                    <div class="icon-wrapper"> <i @click="deleteItemAvail(model.campaignMedias, ind, media.line_item_list, index)" class="icon-deleted"></i> </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="line-wrapper">
            <hr class="line" />
          </div>
          <div class="addNewButton">
            <button @click="addNewLineItem" class="color-red">Add new</button>
          </div>
        </div>
    </div>
    
  </div>
</template>

<script>
import Vue from "vue";
import api from "@/api"
import lib from "@/lib/util"
import { apiV2 } from "@/api/urls"
import { helpers } from "@/lib/validation/"
import { mapGetters } from "vuex"
import { restEdge } from "@/api/edgeUrls"
import { globalMixins } from "@/lib/mixins/globalMixins"
import { required, minLength } from 'vuelidate/lib/validators'
import { ACheckbox, AInput, ATextArea, ASelectDropdown, AModal, ALoadingSecondary, AListDropdown,
        ALoadingSecondaryWhite, ASingleSearchDropdown, ALoadingPrimary, AEmptySelection, APagination} from "ui-kit-v1"
import moment from "moment";

export default {
  name: "outdoor-campaign-editor",
  components: {
    "adx-loading": ALoadingPrimary,
    "adx-loading-2": ALoadingSecondary,
    "adx-loading-white": ALoadingSecondaryWhite,
    "adx-pagination": APagination,
    "adx-dropdown-sort": ASelectDropdown,
    "adx-dropdown-list": AListDropdown,
    "adx-single-search-dropdown": ASingleSearchDropdown,
    "adx-input": AInput,
    "adx-select-dropdown": ASelectDropdown,
    "adx-modal": AModal,
    "adx-empty-selection": AEmptySelection,
  },
  mixins: [globalMixins],
  props: {
    campaignData: {
      required: false
    },
    isSummary: {
      required: false
    },

  },
  data() {
    return {
      id: null,
      channelName: null,
      item: [],
      durationKey: 0,
      quotation: 1,
      // newPlacement: null,
      isShowModal: false,
      isEditor: true,
      isLoading: false,
      isLoadingForm: false,
      isLoadingSave: false,
      popoverVisibility: `focus`,
      
      unitRender: 0,
      model: {
        name: 'null',
        media_type: null,
        digitalMedia: null,
        nonDigitalMedia: null,
        selectedDuration: 1,
        subTotalPrice: 0,
        items: [],
        campaignMedias: [],
        startDate: null,
        endDate: null,
        campaignPeriod: 1,
        minDuration: 10,
      },
      date:{
        digitalStartDate : null,
        digitalEndDate : null,
        nonDigitalStartDate : null,
        nonDigitalEndDate : null,
      },
      durationOptions: [
        {
          id: 1,
          label: '10 Seconds',
          value: 10
        },
        {
          id: 2,
          label: '15 Seconds',
          value: 15
        }, 
        {
          id: 3,
          label: '30 Seconds',
          value: 30
        },
        {
          id: 4,
          label: '45 Seconds',
          value: 45
        }
      ],
      placementOptions: [], 
      fullPlacementOptions: [],
      vuelidateOptions: {
        name: {
          field: 'campaign name',
          error: null,
          ref: 'name'
        },
        serviceFee: {
          field: 'service fee',
          error: null,
          ref: 'serviceFee'
        }
      },
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
      },
    };
  },
  validations: {
    model: {
      name: { required, minLength: minLength(3) },
    },
  },
  computed: {
    ...mapGetters({
      token: "token",
      isSuperuser: "isSuperuser"
    }),
  },
  watch: {
    'model.name':function(){
      this.$emit('updateSummary', {campaignName: this.model.name})
    }
  },
  apollo: {

  },
  beforeCreate() {

  },
  async created() {
  
  },
  async beforeMount() {

  },
  async mounted() {
    this.mapCampaignData(this.campaignData)
  },

  beforeUpdate() {

  },
  updated() {
    
  },
  activated() {

  },
  deactivated() {
    
  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    mapCampaignData(data){
      this.channelName = data.channel_name
      this.model.media_type = data
      this.model.name = data.name
      this.model.id = data.id
      this.model.subTotalPrice = data.total_price
      this.model.owner = data.owner
      this.model.startDate = this.displayDate(data.start)
      this.model.endDate = this.displayDate(data.end)
      this.model.campaignMedias = data.campaign_medias

      //get min period
      let periods = []
      data.campaign_medias.map(media => {periods.push(media.period) })
      this.model.minPeriode = Math.max.apply(Math, periods)

      //get duration
      let durations = []
      data.campaign_medias.map(media => {durations.push(media.duration)})
      this.model.minDuration = Math.min.apply(Math, durations)
      this.model.campaignDuration = this.model.minDuration

      //define media campaign type
      data.campaign_medias.map(media =>{
        media.media_type.toLowerCase()  == 'digital' ? this.model.digitalMedia = media 
        : this.model.nonDigitalMedia = media
      })

      // assign date value and period
      // this.model.selectedDuration = this.model.minPeriode
      this.model.campaignPeriod = this.model.minPeriode
      if(this.model.digitalMedia){
        // this.date.digitalStartDate = this.displayDate(this.model.digitalMedia.start)
        this.date.digitalStartDate = new Date(this.model.digitalMedia.start)
        this.date.digitalEndDate = this.displayDate(this.model.digitalMedia.end)
      }
      if(this.model.nonDigitalMedia){
        // this.date.nonDigitalStartDate = this.displayDate(this.model.nonDigitalMedia.start)
        this.date.nonDigitalStartDate = new Date(this.model.nonDigitalMedia.start)
        this.date.nonDigitalEndDate = this.displayDate(this.model.nonDigitalMedia.end)
      }
      // setTimeout(() => {}, 6000);
      //send summary emit to parent

      this.getTotalItemAndPrice(this.model.campaignMedias, this.model.campaignDuration)
      this.$emit('updateSummary', {
        campaignStart: this.model.startDate, 
        campaignEnd: this.model.endDate,
        campaignPeriod: this.model.campaignPeriod
      })
      this.getOutdoorDate()
    },
    updateEndDate(selected, startDate, type){
      let period = 0
      // if(type == 'digital'){
      //   if (selected) {
      //     if (selected.item.value >= data.selectedDuration ) {
      //       period = selected.item.value
      //       this.model.selectedDuration = period
      //     } else {
      //       period = data.selectedDuration
      //       this.showNotificationAlert("Error", "minimum period for this media is " + data.selectedDuration + " month(s)", "danger");
      //       this.model.selectedDuration = data.selectedDuration
      //       this.durationKey += 1;
      //     }
      //   } else {
      //     period = data.selectedDuration
      //     this.model.selectedDuration = period
      //   }
      // }else{
      //   period = 1
      //   this.model.selectedDuration = 1
      // }
      this.model.campaignDuration = selected.item.value
      period = this.model.campaignPeriod
      //get end date after change period
      let start = new Date(startDate)
      let end = new Date(startDate);
      
      if (type == 'digital') {
        end.setMonth(end.getMonth() + period);
        this.date.digitalEndDate = end
      } else {
        end.setMonth(end.getMonth() + period);
        this.date.nonDigitalEndDate = end
      }
      this.getOutdoorDate()
      this.getSummaryDate(start, end, type)
      this.$emit('updateSummary', { campaignPeriod: period, campaignDuration: this.model.campaignDuration })
      this.getTotalItemAndPrice( this.model.campaignMedias, this.model.campaignDuration)
    },
    getEndDate(date, type){
      var end = null
      end = new Date(date);
      if (type == 'digital') {
        end.setMonth(end.getMonth() + this.model.campaignPeriod);
      } else {
        end.setMonth(end.getMonth() + this.model.campaignPeriod);
      }

      end.setDate(end.getDate() - 1)

      return this.displayDate(end)
    },
    getOutdoorDate(){
      this.$emit('updateSummary', {
        digitalStartDate : this.date.digitalStartDate ,
        digitalEndDate : this.date.digitalEndDate,
        nonDigitalStartDate : this.date.nonDigitalStartDate,
        nonDigitalEndDate : this.date.nonDigitalEndDate,
      })
    },
    getSummaryDate(startDate, endDate, type){
      let startList = []
      let endList = []

      if (this.date.digitalStartDate) {
        startList.push(new Date(this.date.digitalStartDate))

        let digitalEnd = new Date(this.date.digitalStartDate);
        digitalEnd.setMonth(digitalEnd.getMonth() + this.model.campaignPeriod);
        digitalEnd.setDate(digitalEnd.getDate() - 1)

        endList.push(digitalEnd)
        
      }
      if (this.date.nonDigitalStartDate) {
        startList.push(new Date(this.date.nonDigitalStartDate))
        let nonDigitalEnd = new Date(this.date.nonDigitalStartDate);
        nonDigitalEnd.setMonth(nonDigitalEnd.getMonth() + this.model.campaignPeriod);
        nonDigitalEnd.setDate(nonDigitalEnd.getDate() - 1)

        endList.push(nonDigitalEnd)
      }

      let start = null
      let end = null 
      start = this.displayDate(Math.min.apply(Math, startList))
      end = this.displayDate(Math.max.apply(Math, endList))

      this.$emit('updateSummary', {
        campaignStart: start,
        campaignEnd: end,
        digitalStartDate : this.date.digitalStartDate ,
        digitalEndDate : this.date.digitalEndDate,
        nonDigitalStartDate : this.date.nonDigitalStartDate,
        nonDigitalEndDate : this.date.nonDigitalEndDate,
      })
    },
    deleteItemAvail(media, ind, item, index){
      let item_id = item[index].id

      if (media.length == 1 && media.line_item_list == 1) {
        this.showNotificationAlert(
            "Error", 
            "minimum one placement for this campaign",
            "danger");
      } else {
        item.splice(index, 1);
        if (item.length == 0) {
          media.splice(ind, 1);
        }
      }
      this.getTotalItemAndPrice(media)
    },
    getTotalItemAndPrice(campaignMedias, campaignDuration){
      let totalItem = 0
      let totalPrice = 0
      for (let media of campaignMedias) {
        totalItem += media.line_item_list.length
        for (let item of media.line_item_list) {
            campaignDuration 
              ? totalPrice += item.price * (item.line_item.min_period / this.model.minPeriode) 
              : totalPrice += item.price * item.slot
        }
      }
      totalPrice = campaignDuration >= this.model.minDuration
        ? totalPrice * (campaignDuration / this.model.minDuration) + 70
        : totalPrice
      this.$emit('updateSummary', {
        itemCount: totalItem, 
        subTotalPrice: totalPrice
      });
    },
    addNewLineItem(){
      this.$emit('addNewLineItem', {isShowModal: true});
    },
    getUnitItem(maxQuantity){
      let i = 1
      let unitItemOption = []
      for (i = 1; i <= maxQuantity; i++){
        unitItemOption.push({
          id : i,
          label : `${i}` + `${' Unit'}`,
          value : i
        })
      }
      return unitItemOption
    },
    changeItemUnit(mediaidx, listindx, item){
      let media = this.model.campaignMedias
      this.getTotalItemAndPrice(media, this.model.selectedDuration)
    },
    minDate(item) {
      var date = new Date();
      date.setDate(date.getDate() + 3);
      return date
    },
    getObjectAvail(id){
      return this.fullPlacementOptions.filter(x => {return x.id == id})
    },
    displayDate(date){
      return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', new Date(date))}`
    },
    validateCampaign(isCreateQuotation){
      this.model.serviceFee = this.model.serviceFee? this.model.serviceFee : 0
      this.$v.$touch()
      if (this.$v.model.$invalid) {
        this.vuelidateHelper(this.vuelidateOptions)
      } else {
        if (isCreateQuotation) {
          // this.createQuotation()
          this.toggleModalQuotation()
          
        } else {
          this.saveToDraft(false)
        }
      }
    },
    vuelidateHelper(vuelidateOptions){
      const { key, message, element, collection } = helpers.vuelidateValidationHelper(this.$v.model, vuelidateOptions, this.$refs)

      if (collection) {
        vuelidateOptions[key].error[collection.index][collection.collectionKey] = message
      } else {
        vuelidateOptions[key].error = message
      }
      if (typeof element[0] == "undefined") {
        this.$nextTick(function() {
          element.scrollIntoView();
        });
      } else {
        this.$nextTick(function() {
          if (element[0].hasOwnProperty("$el")) {
            element[0].$el.scrollIntoView();
          } else {
            element[0].scrollIntoView();
          }
        });
      }
      this.saveLoading = false
    },
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>
<style lang='scss'>
.editorCampaign-outdoor__summary-section__container__item{
  .periodWrapper{
    .selectDropdown .select input{
      min-height: 63px;
    }
  }
}
</style>